export const findLastMentionString = (s: string) => {
  const lastAtIndex = s.search(/[@][^@]*$/g);
  return {
    filter: lastAtIndex >= 0 ? s.slice(lastAtIndex + 1) || '' : '',
    lastIndexPosition: lastAtIndex >= 0 ? s.length - lastAtIndex : lastAtIndex,
    atPosition: lastAtIndex,
  };
};
